import * as React from 'react';
import {useEffect, useState} from "react";
import {LocationDomConfig} from "./locationMapTypes";
import CreatePortal from "../CreatePortal";
import LocationMap from "./locationMap";

const LocationMaps = () => {

    const [locations, setLocations] = useState<LocationDomConfig[]|null>(null);

    useEffect(()=>{
        // init all locations maps
        const els = document.getElementsByClassName('js-location-map');
        const configs: LocationDomConfig[] = [];
        Array.from(els).forEach((item)=> {
            const script = item.querySelector(".js-location-map-json")?.textContent;
            if(!!script)
            configs.push({
                mount: item,
                location: JSON.parse(script)
            });
        });
        setLocations(configs);
    }, []);

    if(!locations) return null;

    return <>{locations.map((conf)=>{
        return <CreatePortal key={`portal-location-map-${conf.location.id}`} mount={conf.mount}>
            <LocationMap locations={[conf.location]}/>
        </CreatePortal>
    })}</>
};

export default LocationMaps;